/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
// #region import
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import NotificationSendingForm from '../compornent/PushSend/PushSendForm';
import NotificationSendingConfirm from '../compornent/PushSend/PushSendConfirm';
import { SendRequestDto } from '../../api/PushSendAPI';

import Menu from '../compornent/Menu';

// #endregion import

/**
 * 通知送信画面
 * @param history
 */
const NotificationSending = (props: any) => {
  const { history } = props;
  const { state } = useLocation<SendRequestDto>();
  const [input, setInput] = useState<SendRequestDto | undefined>(state);
  const [isInput, setIsInput] = useState<boolean>(true);

  // #region return
  return (
    <div className="main_contents">
      <Menu history={history} />
      <section id="right_contents" className="notification_sending">
        {isInput ? (
          <NotificationSendingForm
            history={history}
            input={input}
            setInput={setInput}
            setIsInput={setIsInput}
          />
        ) : (
          <NotificationSendingConfirm
            history={history}
            input={input}
            setInput={setInput}
            setIsInput={setIsInput}
          />
        )}
      </section>
    </div>
  );
  // #endregion return
};
export default NotificationSending;
